import { Component, EventEmitter, HostListener, Inject, Input, OnInit, Output } from '@angular/core';
import { GruppeTier } from '../../gruppe-tier/classes/gruppe-tier';
import { KieneBackendApiService } from '../../../services/backend-api/kiene-backend-api.service';
import { API_BASE_URL_SERVICE } from '../../../kiene-core.config';
import { MessageService } from '../../../services/message-service/message.service';
import { HttpParams } from '@angular/common/http';
import { Gruppe } from '../../gruppen/classes/gruppe';
import { Subscription } from 'rxjs';

@Component({
    selector: 'kiene-numberpad',
    templateUrl: './numberpad.component.html',
    styleUrls: ['./numberpad.component.scss'],
})
export class NumberpadComponent implements OnInit {
    numbers = '';
    fontSize = '3em';
    checkBackgroundColor = 'lightgray';
    checkColor = 'gray';
    checkBorderColor = 'transparent';
    ohrmarke = '276031234567890';
    ohrmarkeGefunden = false;

    keinErgebnis: boolean;
    isLoading = false;

    ohrmarken: GruppeTier[];

    ladeOhrmarkeSub: Subscription;

    selectedTier: GruppeTier;
    @Input('isVisible') isVisible = true;
    @Input('gruppe') gruppe: Gruppe;
    @Output('tierGefunden') tierGefunden = new EventEmitter<GruppeTier>();

    constructor(
        private readonly api: KieneBackendApiService,
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
        private readonly messageService: MessageService,
    ) {}

    ngOnInit(): void {}

    @HostListener('window:keyup', ['$event'])
    catchKeyboardEvent(event: KeyboardEvent) {
        if (!this.isVisible) {
            return;
        }
        console.log(event.code);
        if ((event.code.startsWith('Numpad') || event.code.startsWith('Digit')) && !this.isKeyEventFromInput(event)) {
            const splitted = event.code.split(/Numpad|Digit/);
            if (splitted && splitted[1]) {
                this.addNumber(Number.parseInt(splitted[1], 10));
            }
        } else if (event.code === 'Backspace' && !this.isKeyEventFromInput(event)) {
            this.backspace();
        }
    }

    addNumber(number: number) {
        if (this.numbers.length < 10) {
            this.calcFontSize();
            this.numbers += `${number}`;
            this.ladeOhrmarke();
            this.calcFontSize();
        }
    }

    calcFontSize() {
        if (this.numbers.length > 12) {
            this.fontSize = '1.2em';
        } else if (this.numbers.length > 8) {
            this.fontSize = '2em';
        } else {
            this.fontSize = '3em';
        }
    }

    checkOhrmarken() {
        if (this.ohrmarken.length === 1) {
            this.selectedTier = this.ohrmarken[0];
            this.ohrmarke = this.ohrmarken[0].ohrmarke_notnull;
            this.ohrmarkeGefunden = true;
            this.keinErgebnis = false;
            this.checkBackgroundColor = 'green';
            this.checkColor = 'white';
            this.checkBorderColor = 'green';
        } else if (this.ohrmarken.length === 0) {
            this.selectedTier = undefined;
            this.ohrmarke = this.numbers.toString();
            this.ohrmarkeGefunden = false;
            this.keinErgebnis = true;
            this.checkBackgroundColor = this.numbers.length < 10 ? 'lightgray' : 'green';
            this.checkColor = this.numbers.length < 10 ? 'gray' : 'white';
            this.checkBorderColor = 'transparent';
        } else {
            this.selectedTier = undefined;
            this.ohrmarke = 'nicht vorhanden';
            this.ohrmarkeGefunden = false;
            this.keinErgebnis = true;
            this.checkBackgroundColor = 'lightgray';
            this.checkColor = 'gray';
            this.checkBorderColor = 'transparent';
        }
    }

    ladeOhrmarke() {
        this.ohrmarken = [];
        this.checkOhrmarken();
        if (this.numbers.length >= 5) {
            this.isLoading = true;
            let params = new HttpParams();
            params = params.set('gruppe_id', this.gruppe.gruppe_id.toString());
            params = params.set('ohrmarke5', this.numbers);

            this.ladeOhrmarkeSub?.unsubscribe();
            this.ladeOhrmarkeSub = this.api
                .getAll(this.apiBaseUrl + 'gruppe_tier/read_scan_kundenportal.php', params)
                .subscribe({
                    next: response => {
                        this.isLoading = false;
                        this.ohrmarken = response.records;
                        this.checkOhrmarken();
                    },
                    error: error => {
                        this.isLoading = false;
                        this.messageService.errorMessage('Fehler bei der Ohrmarkensuche!', error);
                    },
                });
        }
    }

    check() {
        this.tierGefunden.emit(this.selectedTier);
    }

    backspace() {
        if (this.numbers.length >= 1) {
            this.numbers = this.numbers.substring(0, this.numbers.length - 1);
            this.ladeOhrmarke();
        }

        this.calcFontSize();
    }

    getFirstTenDigits(ohrmarke: string) {
        return ohrmarke.substring(0, ohrmarke.length - 5);
    }

    getLastFiveDigits(ohrmarke: string) {
        return ohrmarke.substring(ohrmarke.length - 5, ohrmarke.length);
    }

    private isKeyEventFromInput(event: KeyboardEvent): boolean {
        if (event.target instanceof Node) {
            switch (event.target.nodeName) {
                case 'INPUT':
                case 'SELECT':
                case 'TEXTAREA':
                    return true;
                default:
                    return false;
            }
        }
        return false;
    }
}
